export default "__VITE_ASSET__vcM3kRmL__"